import { Suspense, useRef } from "react";
import loadable from "@loadable/component";
import { createTrackedLazyComponent as trackLazy } from "../../core/chunk-tracker/component";
import { useLocation } from "react-router-dom";
import {
    META_FOOTER_PATH,
    META_HEADER_PATH,
} from "../../components/AppContainer/constants";
import useViewport from "../../hooks/useViewport";

const GlobalHeader = trackLazy(
    () =>
        import(
            /* webpackChunkName: "GlobalHeader" */
            "../../components/GlobalHeader/component"
        ),
    "GlobalHeader"
);

const GlobalFooter = loadable(() =>
    import("../../components/GlobalFooter/component")
);

const AppStatus = trackLazy(
    () =>
        import(
            /* webpackChunkName: "AppStatus" */ "../../components/AppStatus/component"
        ),
    "AppStatus"
);

const MaintenancePage = () => {
    const location = useLocation();
    const pageRef = useRef(null);
    const viewport = useViewport(pageRef, "viewportLarge");
    const currentPath = location.pathname.replace(/^\//, "");

    const globalHeader = (
        <Suspense>
            <GlobalHeader
                maintenance={true}
                viewport={viewport}
                route={{ path: currentPath, search: location.search }}
            />
        </Suspense>
    );

    if (currentPath === "healthz") {
        return (
            <Suspense>
                <AppStatus status={503} />
            </Suspense>
        );
    }

    if (currentPath.startsWith(META_HEADER_PATH)) {
        return globalHeader;
    }

    if (currentPath.startsWith(META_FOOTER_PATH)) {
        return <GlobalFooter />;
    }

    return (
        <div className="maintenance-page" ref={pageRef}>
            <Suspense>
                <GlobalHeader maintenance={true} />
            </Suspense>
            <div className="maintenance-page-content">
                <h1>🚧 Maintenance</h1>
                <p>
                    CBC.ca is undergoing scheduled maintenance between 2 a.m. -
                    6 a.m. ET. There will be service disruptions during this
                    time. We apologize for any inconvenience.
                </p>
            </div>
            <GlobalFooter />
        </div>
    );
};

export default MaintenancePage;
